import { getLanguageCode, resolve } from 'helpers/utilities';

const isZhLanguage = getLanguageCode()
  ?.toLowerCase()
  ?.startsWith('zh');

const theme = {
  heights: {
    header: {
      desktop: 70,
    },
    tray: {
      mobile: 70,
      tablet: 70,
      desktop: 80,
    },
  },
  colors: {
    body: '#585a5f',
    hairline: '#d5d5d5',
    heading: '#000000',
    primary: '#cd192d',
    buttons: {
      default: '#000000',
      primary: '#cd192d',
      white: '#ffffff',
      racingYellow: '#f0ff00',
      racingYellowDark: '#ddeb00',
    },
  },
  fonts: {
    dinRegular: isZhLanguage
      ? '"NotoSansSC-Regular", "DIN2014-Regular", Arial, Helvetica, sans-serif'
      : '"DIN2014-Regular", Arial, Helvetica, sans-serif',
    dinDemi: isZhLanguage
      ? '"NotoSansSC-Medium", "DIN2014-Demi", Arial, Helvetica, sans-serif'
      : '"DIN2014-Demi", Arial, Helvetica, sans-serif',
  },
  breakpoints: {
    mobileEnd: 480,
    tablet: 768,
    tabletLarge: 1024,
    desktop: 1260,

    additional: {
      mobile: 375,
      desktopLarge: 1440,
    },
  },
};

export default theme;

export const minBp = breakpoint => `(min-width: ${resolve(theme.breakpoints, breakpoint)}px)`;
export const maxBp = breakpoint => `(max-width: ${theme.breakpoints[breakpoint] - 1}px)`;
